<div class="page-not-found-container"  *ngIf="showPageNotFound">
  <div class="content">
    <img src="assets/mascot/Mascot_sorry-Grey@2x.webp" alt="odaring mascot"/>
    <h1 class="heading-8">{{'page.not.found.title.1' | translate}}</h1>
    <button type="button" (click)="navigateHome()">{{'button.back.home' | translate}}</button>
  </div>
</div>
